import { Component, Input, Output, EventEmitter } from '@angular/core';
import { slideInOut } from '@dgx-pr-spa/shared/util';

@Component({
  selector: 'app-add-extra',
  templateUrl: './add-extra.component.html',
  styleUrls: ['./add-extra.component.scss'],
  animations: [slideInOut],
})
export class AddExtraComponent {
  /**
   * Emits a checked event back to the parent component
   */
  @Output() checked: EventEmitter<boolean> = new EventEmitter();

  /**
   * Receives isReadonly boolean
   */
  @Input() isReadonly = false;

  /**
   * Receives isDisabled boolean
   */
  @Input() isDisabled = false;

  /**
   * Receives isChecked boolean
   */
  @Input() isChecked = false;

  /**
   * Receives isLoaded boolean
   */
  @Input() isLoaded = true;

  /**
   * Boolean flag to toggle a hint text box
   */
  @Input() hasHint = false;

  /**
   * Tracks state of help accordion
   */
  @Input() isOpen = false;

  /**
   * Receives checkbox state from child checkbox component
   */
  onChecked(checked: boolean) {
    this.isChecked = checked;
    this.checked.emit(checked);
  }

  /**
   * Toggles the help dialog for disabled extras
   */
  onToggleClick() {
    this.isOpen = !this.isOpen;
  }
}
